import { apiGet } from './apiClient';

export type ResolvedPlace = { label: string; placeId: string };

type GeocodeResponse = {
  result: { address: string; placeId: string; location: { lat: number; lng: number } | null } | null;
};

/**
 * Slår upp fri adresstext → ett konkret ställe (place_id) via proxyns
 * forward-geocoding. Returnerar null när Google inte hittar adressen
 * (ZERO_RESULTS). Kastar vid nätverks-/serverfel.
 */
export async function geocodeAddress(
  address: string,
  signal?: AbortSignal,
): Promise<ResolvedPlace | null> {
  const data = await apiGet<GeocodeResponse>('geocode', { address }, signal);
  if (!data.result || !data.result.placeId) return null;
  return { label: data.result.address || address, placeId: data.result.placeId };
}

/**
 * Slår upp en koordinat → läsbar adress (reverse geocoding). Returnerar null
 * när ingen adress hittas. Kastar vid nätverks-/serverfel.
 */
export async function reverseGeocode(
  latlng: string,
  signal?: AbortSignal,
): Promise<ResolvedPlace | null> {
  const data = await apiGet<GeocodeResponse>('geocode', { latlng }, signal);
  if (!data.result || !data.result.address) return null;
  return { label: data.result.address, placeId: data.result.placeId };
}
